import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/* ---------- Objectives / OKRs ---------- */

export async function listObjectives() {
  const { data } = await client.get('/objectives');
  return data.objectives || [];
}

export async function createObjective(payload) {
  const { data } = await client.post('/objectives', payload);
  return data.objective;
}

export async function updateObjective(id, payload) {
  const { data } = await client.put(`/objectives/${id}`, payload);
  return data.objective;
}

export async function deleteObjective(id) {
  await client.delete(`/objectives/${id}`);
}

export async function seedObjectivesFromAI({ clear = false, dry_run = false } = {}) {
  const { data } = await client.post('/objectives/seed-from-ai', { clear, dry_run });
  return data;
}

/* ---------- Polls / encuestas ---------- */

export async function listPolls(params = {}) {
  const { data } = await client.get('/polls', { params });
  return data.polls || [];
}

export async function createPoll(payload) {
  const { data } = await client.post('/polls', payload);
  return data.poll;
}

export async function deletePoll(id) {
  await client.delete(`/polls/${id}`);
}

/* ---------- Speeches / discursos ---------- */

export async function listSpeeches() {
  const { data } = await client.get('/speeches');
  return data.speeches || [];
}

export async function createSpeech(payload) {
  const { data } = await client.post('/speeches', payload);
  return data.speech;
}

export async function deleteSpeech(id) {
  await client.delete(`/speeches/${id}`);
}

/* ---------- Social profiles + snapshots ---------- */

export async function listSocialProfiles() {
  const { data } = await client.get('/social-profiles');
  return data.profiles || [];
}

export async function createSocialProfile(payload) {
  const { data } = await client.post('/social-profiles', payload);
  return data.profile;
}

export async function getSocialProfile(id) {
  const { data } = await client.get(`/social-profiles/${id}`);
  return data;
}

export async function deleteSocialProfile(id) {
  await client.delete(`/social-profiles/${id}`);
}

export async function addManualSnapshot(id, payload) {
  const { data } = await client.post(`/social-profiles/${id}/snapshot`, payload);
  return data.snapshot;
}

export async function listSocialRuns() {
  const { data } = await client.get('/social-runs');
  return data;
}

/* ---------- Election results ---------- */

export async function listElections(date) {
  const { data } = await client.get('/elections', { params: date ? { date } : undefined });
  return data.results || [];
}

export async function createElection(payload) {
  const { data } = await client.post('/elections', payload);
  return data.result;
}

export async function deleteElection(id) {
  await client.delete(`/elections/${id}`);
}

const platformService = {
  listObjectives, createObjective, updateObjective, deleteObjective, seedObjectivesFromAI,
  listPolls, createPoll, deletePoll,
  listSpeeches, createSpeech, deleteSpeech,
  listSocialProfiles, createSocialProfile, getSocialProfile, deleteSocialProfile, listSocialRuns,
  listElections, createElection, deleteElection,
};
export default platformService;
